// extracted by mini-css-extract-plugin
export default {"title":"forms_title__p-OAZ","removeIcon":"forms_removeIcon__5lLH+","removeBtn":"forms_removeBtn__-MEZ5","memberForm":"forms_memberForm__4QO-q"};